import "core-js/modules/es6.function.name";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
import echarts from "echarts";
import { on, off } from "@/libs/tools";
export default {
  name: "ChartBar",
  props: {
    timestampsLine: Array,
    dianliuLine: Array,
    dianliuLine1: Array,
    shengyurongliangLine: Array,
    yachaLine: Array,
    zongdianyaDataLine: Array,
    chongdianDataLine: Array,
    fangdianDataLine: Array,
    moswendu: Array,
    huanjingwendu: Array,
    NTC4: Array,
    NTC3: Array,
    NTC2: Array,
    NTC1: Array,
    alarm_str: Array,
    chongdianmos: Number,
    fangdianmos: Number,
    mosState: Object
  },
  data: function data() {
    return {
      dom: null
    };
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    // 获取报警点数据 - 在x轴上标记报警位置
    getAlarmPoints: function getAlarmPoints() {
      var _this = this;

      if (!this.alarm_str || !this.timestampsLine) return [];
      var alarmPoints = [];
      this.alarm_str.forEach(function (alarm, index) {
        if (alarm && _this.zongdianyaDataLine[index] !== undefined) {
          // 检查 index 合法性
          var yValue = 0; // 示例计算

          var timestamp = _this.timestampsLine[index]; // 根据 alarm 的状态设置颜色

          var color;

          if (alarm.web_flag_gz === 1) {
            color = 'red';
          } else if (alarm.web_flag_gz === 2) {
            color = 'yellow';
          } else {
            color = '#ECF004'; // 默认颜色
          }

          alarmPoints.push({
            name: timestamp,
            value: [timestamp, yValue],
            alarmInfo: alarm,
            // 存储报警信息
            color: color // 将颜色纳入报警点数据中

          });
        }
      });
      console.log('Alarm Points:', alarmPoints); // 记录报警点信息

      return alarmPoints;
    },
    setChartOptions: function setChartOptions() {
      var _this2 = this,
          _ref,
          _ref2;

      // 生成报警点数据
      var alarmPoints = this.getAlarmPoints();
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            animation: false
          },
          formatter: function formatter(params) {
            var timeIndex = params[0].dataIndex;
            var time = _this2.timestampsLine[timeIndex];
            var tooltipContent = "<div class=\"custom-tooltip\">".concat(time, "<br/>");
            params.forEach(function (param) {
              if (param.seriesName !== '报警点') {
                tooltipContent += "\n              <span style=\"display:inline-block;width:10px;height:10px;background-color:".concat(param.color, ";margin-right:5px;border-radius: 5px;\"></span>\n              ").concat(param.seriesName, ": ").concat(param.data, "<br/>\n            ");
              }
            }); // 添加MOS状态

            var mosOff = _this2.mosState.chongdianmos == 1 ? _this2.$t('开启') : _this2.$t('关闭');
            tooltipContent += "".concat(_this2.$t('充电MOS'), ": ").concat(mosOff, "<br/>");
            var mosOn = _this2.mosState.fangdianmos == 1 ? _this2.$t('开启') : _this2.$t('关闭');
            tooltipContent += "".concat(_this2.$t('放电MOS'), ": ").concat(mosOn, "<br/>"); // 添加报警信息

            var currentAlarm = _this2.alarm_str[timeIndex];

            if (currentAlarm) {
              var color = currentAlarm.web_flag_gz === 1 ? 'red' : currentAlarm.web_flag_gz === 2 ? 'yellow' : 'transparent';
              tooltipContent += "\n            <span style=\"display:inline-block;width:10px;height:10px;background-color:".concat(color, ";margin-right:5px;border-radius: 5px;\"></span>\n            ").concat(currentAlarm.alarm_str, "<br/>\n          ");
            }

            tooltipContent += "</div>";
            return tooltipContent;
          }
        },
        legend: {
          data: [this.$t('SOC') + "(%)", this.$t('电压') + "(V)", this.$t('充电电流'), this.$t('放电电流'), this.$t('压差') + "(mV)", this.$t('MOS温度') + "(℃)", this.$t('环境温度') + "(℃)", this.$t('NTC1') + "(℃)", this.$t('NTC2') + "(℃)", this.$t('NTC3') + "(℃)", this.$t('NTC4') + "(℃)"],
          orient: "vertical",
          right: "00px",
          top: "50px",
          itemGap: 10
        },
        axisPointer: {
          link: [{
            xAxisIndex: "all"
          }]
        },
        dataZoom: [{
          show: false,
          realtime: true,
          start: 0,
          end: 100,
          xAxisIndex: [0, 1],
          handleStyle: {
            color: "#fff",
            borderColor: "black"
          },
          fillerColor: "rgba(0, 0, 0, 0)"
        }, {
          type: "inside",
          realtime: true,
          start: 0,
          end: 100,
          xAxisIndex: [0, 1]
        }],
        grid: [{
          left: 60,
          right: 150,
          height: "35%"
        }, {
          left: 60,
          right: 150,
          top: "55%",
          height: "35%"
        }],
        xAxis: [(_ref = {
          type: "category",
          axisLine: {
            onZero: true
          },
          data: this.timestampsLine,
          offset: 20
        }, _defineProperty(_ref, "axisLine", {
          lineStyle: {
            color: "rgba(127, 132, 139, 1)"
          }
        }), _defineProperty(_ref, "axisLabel", {
          color: "rgba(127, 132, 139, 1)"
        }), _ref), (_ref2 = {
          gridIndex: 1,
          type: "category",
          axisLine: {
            onZero: true
          },
          data: this.timestampsLine,
          position: "top",
          show: true,
          offset: 22
        }, _defineProperty(_ref2, "axisLine", {
          lineStyle: {
            color: "rgba(127, 132, 139, 1)"
          }
        }), _defineProperty(_ref2, "axisLabel", {
          color: "rgba(127, 132, 139, 1)"
        }), _ref2)],
        yAxis: [{
          type: "value",
          axisLine: {
            lineStyle: {
              color: "rgba(127, 132, 139, 0)"
            }
          },
          axisLabel: {
            color: "rgba(127, 132, 139, 1)"
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#ccc"
            }
          }
        }, {
          gridIndex: 1,
          type: "value",
          inverse: true,
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#ccc"
            }
          },
          axisLine: {
            lineStyle: {
              color: "rgba(127, 132, 139, 0)"
            }
          },
          axisLabel: {
            color: "rgba(127, 132, 139, 1)"
          }
        }],
        series: [{
          name: this.$t('电压') + "(V)",
          type: "line",
          symbolSize: 8,
          data: this.zongdianyaDataLine,
          itemStyle: {
            color: "rgba(255, 154, 46, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t('SOC') + "(%)",
          type: "line",
          symbolSize: 8,
          data: this.shengyurongliangLine,
          itemStyle: {
            color: "rgba(25, 190, 107, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t('充电电流'),
          type: "line",
          symbolSize: 8,
          data: this.dianliuLine,
          itemStyle: {
            color: "rgba(45, 140, 240, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t('放电电流'),
          type: "line",
          symbolSize: 8,
          data: this.dianliuLine1,
          itemStyle: {
            color: "rgba(247, 114, 52, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t('MOS温度') + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.moswendu,
          itemStyle: {
            color: "#8D4EDA"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t('环境温度') + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.huanjingwendu,
          itemStyle: {
            color: "#9FBD1D"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t('NTC1') + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.NTC1,
          itemStyle: {
            color: "#E13EDB"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t('NTC2') + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.NTC2,
          itemStyle: {
            color: "rgba(240, 139, 180, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t('NTC3') + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.NTC3,
          itemStyle: {
            color: "rgba(150, 97, 188, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t('NTC4') + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.NTC4,
          itemStyle: {
            color: "rgba(101, 120, 155, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t('压差') + "(mV)",
          type: "line",
          xAxisIndex: 1,
          yAxisIndex: 1,
          symbolSize: 8,
          data: this.yachaLine,
          itemStyle: {
            color: "rgba(14, 197, 192, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, // 添加报警点系列 - 显示黄色圆点
        {
          name: '报警点',
          type: 'scatter',
          xAxisIndex: 0,
          yAxisIndex: 0,
          data: alarmPoints.map(function (point) {
            return {
              name: point.name,
              value: point.value,
              alarmInfo: point.alarmInfo,
              itemStyle: {
                color: point.color // 使用动态颜色

              }
            };
          }),
          symbolSize: 12,
          // 稍大一点，更显眼
          zlevel: 10
        }]
      };
      this.dom.setOption(option);
    }
  },
  mounted: function mounted() {
    this.dom = echarts.init(this.$refs.dom);
    this.setChartOptions();
    on(window, "resize", this.resize);
  },
  watch: {
    timestampsLine: function timestampsLine() {
      this.setChartOptions();
    },
    dianliuLine: function dianliuLine() {
      this.setChartOptions();
    },
    shengyurongliangLine: function shengyurongliangLine() {
      this.setChartOptions();
    },
    yachaLine: function yachaLine() {
      this.setChartOptions();
    },
    zongdianyaDataLine: function zongdianyaDataLine() {
      this.setChartOptions();
    },
    chongdianDataLine: function chongdianDataLine() {
      this.setChartOptions();
    },
    fangdianDataLine: function fangdianDataLine() {
      this.setChartOptions();
    },
    alarm_str: function alarm_str() {
      this.setChartOptions();
    }
  },
  beforeDestroy: function beforeDestroy() {
    off(window, "resize", this.resize);
  }
};